import styled from 'styled-components';

export default {
  Wrapper: styled.div<{
    isFullscreen: boolean;
    withDates: boolean;
  }>`
    flex-grow: 1;
    background-color: ${({ theme }) => theme.backgroundColor || '#f5f5f5'};
    z-index: 1;
    overflow-y: scroll;
  `,
};
